<div
  class="w-[260px] 2xl:h-[210px]
    3xl:w-[294px] 3xl:h-[243px] 
    4xl:w-[324px] 4xl:h-[248px] bg-gray-100 animate-pulse rounded-lg hover:border-gray-400 px-4 py-6"
>
  <!--<div class=" w-[320px] h-[300px] bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:border-gray-300 transition-all duration-300 transform hover:scale-105 px-4 py-6"> -->

  <div class="mb-4">
    <div
      class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"
    ></div>
  </div>

  <div class="space-y-2 text-[0.69em]">
    <div class="flex">
      <div
        class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-24 mb-4"
      ></div>
    </div>
    <div>
      <div
        class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-40 mb-4"
      ></div>
    </div>
    <div
      class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"
    ></div>
  </div>
  <div class="flex flex-row">
    <!--<div
      class="w-[106px] h-[38px] mt-4 rounded-lg px-4 py-2.5 text-center me-2 mb-2 bg-gray-200"
    ></div>-->
    <div
      class="w-[212px] 2xl:w-[212px] 3xl:w-[244px] 4xl:w-[274px] h-[36px] 3xl:h-[40px] 4xl:h-[42px] relative top-0 3xl:top-2 mt-4 rounded-lg px-4 py-2.5 text-center me-2 mb-2 bg-gray-200"
    ></div>
  </div>
</div>
